import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter } from 'react-router-dom';
import App from "./App.jsx";
import { ToastContainer } from "react-toastify";
import IntercomProvider from "./context/IntercomProvider";
import { AuthProvider } from "./context/AuthContext";
import { TokenProvider } from "./context/TokenContext.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter basename="/">
      <AuthProvider>
        <TokenProvider>
          <IntercomProvider>
            <App />
            <ToastContainer autoClose={1000} />
          </IntercomProvider>
        </TokenProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);